import { Command } from 'ckeditor5'

import { CommandParams } from './placeholderUI'

export default class PlaceholderCommand extends Command {
  execute({ name, nameTranslation }: CommandParams) {
    const { editor } = this
    const { selection } = editor.model.document

    editor.model.change(writer => {
      // Creates a <placeholder> element with the "name" and "nameTranslations" attributes (and all the selection attributes)
      const placeholder = writer.createElement('placeholder', {
        ...(Object.entries(selection.getAttributes()) as object),
        name,
        nameTranslation,
      })

      // insert into document
      editor.model.insertContent(placeholder)

      // Put the selection on the inserted element
      writer.setSelection(placeholder, 'on')
    })
  }

  refresh() {
    const { model } = this.editor
    const { selection } = model.document

    const isAllowed = model.schema.checkChild(
      selection.focus?.parent as any,
      'placeholder',
    )
    this.isEnabled = isAllowed
  }
}
